import { CardPhotoType, PriorityMedia } from '@/containers/PriorityDetail/utils'

import { Photos } from './cate-graphql-generated-types'

export enum PropertyType {
  Listing = 'listing',
  Priority = 'priority',
}

type CommonCardData = {
  bathrooms: number
  buildingFloors: number
  city: string
  commercialArea: number
  energyRating: string
  entranceFloor: number
  floorPosition: string[]
  hasOutdoorSpace: boolean
  id: string
  photos: CardPhotoType[]
  price: { cents: number; currency: string }
  rooms: number
  stateOfMaintenance: string
  title: string
  zone: { label?: string; slug?: string }
}

export type CardDataListing = CommonCardData & {
  entireBuilding: boolean
  inventory: string
  isPrivateNegotiation: boolean
  ownedByCasavo: boolean
  photos: Photos[]
  type: PropertyType
}

export const isCardPriority = (cardData: CardData): cardData is CardDataPriority => {
  return cardData.type === PropertyType.Priority
}

export type CardDataPriority = CommonCardData & {
  estimatedListingPrice: { cents: number; currency: string }
  insertedAt: string
  isPrivateNegotiation?: boolean
  photos: CardPhotoType[]
  slug: string
  status: string
  type: PropertyType
}

export type CardData = CardDataListing | CardDataPriority
